import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import GrabbableObject from '../misc/GrabbableObject'
import Icon from '../misc/Icon'
import Label from '../misc/Label'
import { appPrimaryColor, animatedText } from '../Store'
import { get } from 'svelte/store'

const gltfLoader = new GLTFLoader()

export default class AnimatedScene extends THREE.Object3D {
    constructor(controls) {
        super()
        this.controls = controls
        this.loadIcons()
        this.clock = new THREE.Clock()
        this.actions = []
        const textScale = 0.65
        const label = new Label('#beamForming', 1 * textScale, 2 * textScale)
        this.label = label
        label.position.y = 0.75
        label.position.z = 0.25
        this.add(label)
    }

    tick() {
        const delta = this.clock.getDelta()
        if (this.mixer) this.mixer.update(delta)
    }

    async loadIcons() {
        const playButton = new Icon(this.controls, { src: 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Play.png', color: 'white', height: 0.15, width: 0.15 })
        const pauseButton = new Icon(this.controls, { src: 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Pause.png', color: 'white', height: 0.15, width: 0.15 })
        const rewindButton = new Icon(this.controls, { src: 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Rewind.png', color: 'white', height: 0.15, width: 0.15 })

        this.add(playButton)
        this.add(pauseButton)
        this.add(rewindButton)

        pauseButton.position.set(-0.2, 0.25, 0.25)
        rewindButton.position.set(0, 0.25, 0.25)
        playButton.position.set(0.2, 0.25, 0.25)

        const { model, gltf } = await this.loadDoner()
        this.add(model)
        model.position.set(0, 1.5, -0.5)
        model.rotation.set(0, -Math.PI / 3, 0)

        this.mixer = new THREE.AnimationMixer(model)
        const mixer = this.mixer
        gltf.animations.forEach(clip => {
            try {
                const action = mixer.clipAction(clip)
                this.actions = [...this.actions, action]
            } catch (e) {
                2
                console.log(e)
            }
        })

        playButton.addEventListener('click', () => {
            this.play()
        })
        pauseButton.addEventListener('click', () => {
            this.pause()
        })
        rewindButton.addEventListener('click', () => {
            this.reset()
        })

        this.playButton = playButton
        this.pauseButton = pauseButton
        this.rewindButton = rewindButton
        this.dispatchEvent({ type: 'loaded' })
    }

    pause() {
        this.resetIcons()
        this.pauseButton.setColor(appPrimaryColor)
        for (const action of this.actions) {
            action.timeScale = 0
        }
    }

    play() {
        const animatedTextV = get(animatedText)
        if (animatedTextV !== 'playing') {
            animatedText.set('playing')
            this.label.update()
        }
        this.resetIcons()
        this.playButton.setColor(appPrimaryColor)
        for (const action of this.actions) {
            action.timeScale = 1
            action.play()
            action.clampWhenFinished = true
        }
    }

    reset() {
        const animatedTextV = get(animatedText)
        if (animatedTextV !== 'paused') {
            animatedText.set('paused')
            this.label.update()
        }
        this.resetIcons()
        for (const action of this.actions) {
            action.reset()
            action.timeScale = 0
            this.pivot.attach(this.movablePart)
            this.movablePart.position.set(this.movableOriginPosition.x, this.movableOriginPosition.y, this.movableOriginPosition.z)
        }
    }

    resetIcons() {
        const { rewindButton, playButton, pauseButton } = this
        playButton.setColor('white')
        pauseButton.setColor('white')
        rewindButton.setColor('white')
    }
    async loadDoner() {
        const url = 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Doner_white.glb'
        const donerGltf = await gltfLoader.loadAsync(url)
        const model = donerGltf.scene
        console.log(model)
        model.traverse(function (child) {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = false;
            }
        });
        model.children[1].clear()
        this.pivot = model.children[0]
        for (const child of model.children[0].children) {
            if (child.name === '175-0033-04_PCB_Rev_1') {
                const movablePart = new GrabbableObject(this.controls, new THREE.Euler(0, -Math.PI / 3, 0))
                this.movablePart = movablePart
                this.movableOriginPosition = movablePart.position.clone()
                movablePart.add(child)
                model.add(movablePart)
                movablePart.addEventListener('moving', () => {
                    this.pause()
                })
            }
        }

        const scale = 0.3
        model.scale.set(scale, scale, scale)
        model.position.y = 1
        return { model, gltf: donerGltf }

    }
}


